/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { MAIN_THEME } from '@styles';
import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';

const CustomCategoryTreeNode: React.FC<CustomCategoryTreeNode> = ({
  id,
  name,
  children,
  layer,
  onSelectNode,
}) => {
  const { classes, cx } = useStyles({ layer: layer });

  const [open, setOpen] = useState<boolean>(false);

  return layer < 3 ? (
    <Accordion
      classes={{ root: classes.accordionMainContainer }}
      disableGutters
      elevation={0}
      onChange={(e, expanded) => setOpen(expanded)}
    >
      <AccordionSummary
        classes={{
          root: cx(
            classes.accordionSummaryContainer,
            classes.categoryContainer,
            layer === 3 && classes.lastCategoryContainer
          ),
          content: cx(
            classes.accordionSummaryText,
            layer === 1 && classes.accordionSummaryFirstText,
            classes.accordionSummaryIndentedText
          ),
        }}
      >
        <>
          {open ? (
            <ExpandLess fontSize="small" />
          ) : (
            <ExpandMore fontSize="small" />
          )}
          <div
            onClick={(e) => {
              e.stopPropagation();
              onSelectNode();
            }}
            style={{ width: '100%' }}
          >{`${id} ${name}`}</div>
        </>
      </AccordionSummary>
      <AccordionDetails
        classes={{
          root: cx(
            classes.accordionContentContainer,
            layer === 2 && classes.accordionLastContentContainer
          ),
        }}
      >
        {children.map((node) => (
          <CustomCategoryTreeNode
            key={node.id}
            id={node.id}
            name={node.name}
            layer={node.layer}
            onSelectNode={() => node.onSelectNode()}
          >
            {node.children}
          </CustomCategoryTreeNode>
        ))}
      </AccordionDetails>
    </Accordion>
  ) : (
    <AccordionSummary
      classes={{
        root: cx(
          classes.accordionSummaryContainer,
          classes.categoryContainer,
          layer === 3 && classes.lastCategoryContainer
        ),
        content: cx(
          classes.accordionSummaryText,
          layer === 1 && classes.accordionSummaryFirstText,
          classes.accordionSummaryIndentedText
        ),
      }}
    >
      <>
        <div
          onClick={(e) => {
            e.stopPropagation();
            onSelectNode();
          }}
          style={{ width: '100%' }}
        >{`${id} ${name}`}</div>
      </>
    </AccordionSummary>
  );
};

const useStyles = makeStyles<{ layer: number }>()((theme, props) => ({
  accordionMainContainer: {
    padding: 0,
    '::before': {
      backgroundColor: 'transparent',
    },
  },
  accordionSummaryContainer: {
    padding: ' 5px',
    minHeight: 'unset',
  },
  accordionSummaryText: {
    margin: 0,
    color: MAIN_THEME.color.black,
    fontSize: MAIN_THEME.fontSize.sm,
    lineHeight: '16px',
    fontFamily: MAIN_THEME.font.medium,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  accordionSummaryFirstText: {
    fontSize: MAIN_THEME.fontSize.rg,
    lineHeight: '21px',
    fontFamily: MAIN_THEME.font.bold,
  },
  accordionSummaryIndentedText: {
    // - 1 to not indent first layer
    marginLeft: `${(props.layer - 1) * 25}px`,
  },
  accordionSummaryExpanded: {
    margin: 0,
  },
  accordionContentContainer: {
    backgroundColor: MAIN_THEME.color.white98,
    padding: '1px 0 0',
  },
  accordionLastContentContainer: {
    backgroundColor: MAIN_THEME.color.white92,
    boxShadow: 'inset 0 1px 3px hsla(0, 0%, 0%, 0.14)',
  },
  categoryContainer: {
    backgroundColor: MAIN_THEME.color.white98,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: MAIN_THEME.color.white92,
    },
  },
  lastCategoryContainer: {
    backgroundColor: MAIN_THEME.color.white92,
    paddingLeft: '25px',
    ':hover': {
      backgroundColor: MAIN_THEME.color.white86,
    },
  },
}));

export default CustomCategoryTreeNode;
